import { render, staticRenderFns } from "./OriginalDrawingImg.vue?vue&type=template&id=451a449a&scoped=true"
import script from "./OriginalDrawingImg.vue?vue&type=script&lang=js"
export * from "./OriginalDrawingImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a449a",
  null
  
)

export default component.exports